/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { ImageGalleryColorDialogFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { ImageGalleryColorDialogFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const imageGalleryColorDialogDataMock: ImageGalleryColorDialogFragmentFragment = {
  dimensions: [
    {
      axisType: 'COLOR',
      values: [
        {
          displayText: 'schwarz',
          isSelected: false,
          rgb: '000',
          sku: '2717813013',
          variationMainImage:
            'https://bilder.baur.de/i/empiriecom/4024a9aa6aa40047cb50d09695a0a342',
        },
        {
          displayText: 'weiß',
          isSelected: true,
          rgb: 'FFF',
          sku: '9669202279',
          variationMainImage:
            'https://bilder.baur.de/i/empiriecom/6ca53c5418ffc0cc2768b6ad0b928ca5.jpg',
        },
        {
          displayText: 'weiß',
          isSelected: true,
          rgb: 'FFF',
          sku: null,
          variationMainImage:
            'https://bilder.baur.de/i/empiriecom/6ca53c5418ffc0cc2768b6ad0b928ca5.jpg',
        },
      ],
    },
  ],
};

export function getImageGalleryColorDialogFragmentedData(
  data?: ImageGalleryColorDialogFragmentFragment,
) {
  return makeFragmentData(
    data || imageGalleryColorDialogDataMock,
    ImageGalleryColorDialogFragmentFragmentDoc,
  );
}
